import React, { useEffect, useState } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import LoggedInUsersHolidayCalendar from "../../../components/MySpace/CheckinCheckOutAttendanceTable/LoggedInUsersHolidayCalendar";
import WorkAnniversaries from "../../../components/MySpace/WorkAnniversaries";
import UpcomingBirthdays from "../../../components/MySpace/UpcomingBirthdays";
import { LeaveStatus } from "../../../redux/stcoTools/stcoToolsType";
import { LeaveAndWFHListPayloadType } from "../../../commonTypes/stcoToolsType";
import {
  GetAttendanceAveragePayloadType,
  GetMySpacePeopleOnLeavePayloadType,
  GetMySpaceUpcomingEventsDataPayloadType,
} from "../../../commonTypes/mySpaceType";
import { GetHolidayCalenderPayloadType } from "../../../commonTypes/masterDataTypes";
import { HolidayCalenderListType } from "../../../redux/masterData/masterTypes";
import {
  PeopleOnLeaveListType,
  UpcomingBirthdayListType,
  WorkAnniversaryListType,
} from "../../../redux/mySpace/mySpaceTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import HolidayCalenderModalView from "../../../components/MySpace/HolidayCalenderModalView";
import {
  currentDate,
  currentYear,
  current_month_first_date,
  reverseDate,
  reverseDateFormat,
} from "../../../utils/commonFunctions";
import {
  getMasterDataHolidayCalenderAction,
  resetHolidayCalenderList,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
} from "../../../redux/masterData";
import PeopleOnLeave from "../../../components/MySpace/PeopleOnLeave";
import {
  getAllFinacUsersAction,
  resetAuthError,
  resetAuthSuccess,
  resetFinacUsersList,
  resetSession,
  resetUserProfileAllData,
} from "../../../redux/auth";
import { resetUsersProfileSuccess } from "../../../redux/usersProfile";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import EmployeeOnProbation from "../../../components/HRMS/EmployeeOnProbation";
import EmployeeOnProbationModal from "../../../components/HRMS/EmployeeOnProbationModal";
import AverageAttendance from "../../../components/HRMS/AverageAttendance";
import {
  getAttendanceAverageAction,
  getMySpaceUpcomingBirthDayAction,
  getMySpaceWorkAnniversaryAction,
  getPeopleOnLeaveAction,
  resetAttendanceAverage,
  resetMySpaceError,
  resetMySpaceStatusCode,
  resetMySpaceSuccess,
  resetMySpaceWorkAnniversaryList,
  resetPeopleOnLeaveList,
  resetUpcomingBirthdayList,
} from "../../../redux/mySpace";
import PeopleOnLeaveModal from "../../../components/MySpace/PeopleOnLeaveModal";
import OnTimeArrival from "../../../components/HRMS/OnTimeArrival";
import MissingTimesheetUpdates from "../../../components/HRMS/MissingTimesheetUpdates";
import EmployeeByLocation from "../../../components/HRMS/EmployeeByLocation";
import AttendanceByDepartment from "../../../components/HRMS/AttendanceByDepartment";
import { CommonHeader, ErrorSuccessModal } from "../../../components/commons";
import AttendanceDetails from "../../../components/MySpace/AttendanceDetails";
type AppProps = {
  token: string | null;
  allFinacUsersList: any;

  dispatchResetUserProfileAllData: () => void;

  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetUserDetails: () => void;

  // upcoming event
  mySpaceWorkAnniversaryList: WorkAnniversaryListType[] | [];
  upcomingBirthdayList: UpcomingBirthdayListType[] | [];
  upcomingBirthdayTotalCount: number;
  upcomingBirthDayFetching: boolean;
  workAnniversaryfetching: boolean;
  dispatchResetMySpaceWorkAnniversaryList: () => void;
  dispatchResetUpcomingBirthdayList: () => void;
  dispatchGetMySpaceWorkAnniversaryAction: (
    data: GetMySpaceUpcomingEventsDataPayloadType
  ) => void;
  dispatchGetMySpaceUpcomingBirthDayAction: (
    data: GetMySpaceUpcomingEventsDataPayloadType
  ) => void;

  ///calender
  dispatchResetMasterDataHolidayCalenderListing: () => void;
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => void;
  holidayCalenderList: HolidayCalenderListType[] | [];
  dispatchResetCalendarData: () => void;
  dispatchgetSchedulingCalendar: (data: any) => void;
  dispatchResetSession: () => void;

  holidayFetching: boolean;
  masterSuccess: number | null;

  masterStatusCode: number | null;

  masterError: null | string;

  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterStatusCode: () => void;

  dispatchUpcomingLeaveListAction: (data: LeaveAndWFHListPayloadType) => void;
  dispatchResetUpcomingLeaveAndWFHList: () => void;
  leaveStatus: LeaveStatus;
  ///people on leave
  dispatchGetPeopleOnLeaveAction: (
    data: GetMySpacePeopleOnLeavePayloadType
  ) => void;
  peopleOnLeaveFetching: boolean;
  peopleOnLeaveData: PeopleOnLeaveListType[] | [];
  dispatchResetPeopleOnLeaveList: () => void;
  authFetching: boolean;
  ///my space

  dispatchResetMySpaceSuccess: () => void;
  dispatchResetMySpaceError: () => void;
  dispatchResetMySpaceStatusCode: () => void;
  mySpaceSuccess: number | null;
  authSuccess: number | null;
  mySpaceStatusCode: number | null;
  authStatusCode: number | null;
  mySpaceError: null | string;
  authError: null | string;
  dispatchResetAuthError: () => void;

  //attendanceAverage
  dispatchGetAttendanceAverage: (data: GetAttendanceAveragePayloadType) => void;
  dispatchResetAttendanceAverage: () => void;
  attendanceAverageFetching: boolean;
  attendanceAverage: number;
};
const HRDashboard = ({
  token,

  dispatchGetAllFinacUsersAction,
  dispatchResetMasterDataHolidayCalenderListing,
  dispatchGetMasterDataHolidayCalenderAction,
  holidayCalenderList,
  dispatchResetCalendarData,
  holidayFetching,
  masterSuccess,
  masterStatusCode,
  masterError,
  mySpaceWorkAnniversaryList,
  upcomingBirthdayList,
  upcomingBirthDayFetching,
  workAnniversaryfetching,
  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterError,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,

  dispatchGetMySpaceWorkAnniversaryAction,
  dispatchResetMySpaceWorkAnniversaryList,
  dispatchGetMySpaceUpcomingBirthDayAction,
  dispatchResetUpcomingBirthdayList,

  allFinacUsersList,
  dispatchGetPeopleOnLeaveAction,
  peopleOnLeaveFetching,
  peopleOnLeaveData,
  dispatchResetPeopleOnLeaveList,
  authFetching,
  dispatchResetMySpaceSuccess,
  dispatchResetMySpaceError,
  dispatchResetMySpaceStatusCode,
  mySpaceSuccess,
  mySpaceStatusCode,
  mySpaceError,
  dispatchResetAuthError,
  authSuccess,
  authStatusCode,
  authError,
  dispatchResetUserDetails,
  dispatchGetAttendanceAverage,
  dispatchResetAttendanceAverage,
  attendanceAverageFetching,
  attendanceAverage,
}: AppProps) => {
  const [viewAllHolidays, setViewAllHolidays] = useState(false);

  const [holidayData, setHoliDayData] = useState<
    HolidayCalenderListType[] | []
  >([]);

  const [allProbationData, setAllProbationData] = useState(false);
  const [allPeopleOnLeaveData, setAllPeopleOnLeaveData] = useState(false);
  useEffect(() => {
    //user management
    dispatchResetUserDetails();
    dispatchResetPeopleOnLeaveList();
    ///holiday
    setHoliDayData([]);
    dispatchResetMasterDataHolidayCalenderListing();
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetMasterStatusCode();
    ///my sapce
    dispatchResetMySpaceSuccess();
    dispatchResetMySpaceError();
    dispatchResetMySpaceStatusCode();

    // attendanceAverage
    dispatchResetAttendanceAverage();
  }, []);
  //// holiday calendar view all data
  useEffect(() => {
    if (viewAllHolidays) {
      dispatchResetMasterDataHolidayCalenderListing();
      let finalData: GetHolidayCalenderPayloadType = {
        token,
        start_date: `01-01-${currentYear()}`,
        end_date: `31-12-${currentYear()}`,
        country: "India",
        sort_by: "date",
        sort_by_value: "desc",
      };
      dispatchGetMasterDataHolidayCalenderAction(finalData);
    } else {
      dispatchResetMasterDataHolidayCalenderListing();
      let finalData: GetHolidayCalenderPayloadType = {
        token,
        start_date: reverseDate(currentDate()),
        end_date: `31-12-${currentYear()}`,
        country: "India",
        limit: 5,
        sort_by: "date",
        sort_by_value: "asc",
      };
      dispatchGetMasterDataHolidayCalenderAction(finalData);
    }
  }, [viewAllHolidays]);
  //set holiday data
  useEffect(() => {
    if (holidayCalenderList?.length && !viewAllHolidays) {
      setHoliDayData(holidayCalenderList);
    } else if (holidayCalenderList?.length === 0 && !viewAllHolidays) {
      setHoliDayData([]);
    }
  }, [holidayCalenderList]);

  const handleToggleHolidaysModal = () => {
    setViewAllHolidays(!viewAllHolidays);
  };

  const handleToggleProbationModal = () => {
    setAllProbationData(!allProbationData);
  };
  const handleTogglePeopleOnLeaveModal = () => {
    setAllPeopleOnLeaveData(!allPeopleOnLeaveData);
  };

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        employment_status: "Probation",
        user_type: "stco_users",
        status: 1,
      };

      dispatchGetAllFinacUsersAction(finalData);
    }
  }, []);

  ///people on leave
  useEffect(() => {
    if (token) {
      let finalData = {
        token,
      };

      dispatchGetPeopleOnLeaveAction(finalData);
    }
  }, []);

  ///attendanceAverage

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        start_date: current_month_first_date(),
        end_date: reverseDateFormat(currentDate()),
      };
      dispatchGetAttendanceAverage(finalData);
    }
  }, []);

  // upcoming events
  useEffect(() => {
    dispatchResetMySpaceWorkAnniversaryList();
    let finalData: GetMySpaceUpcomingEventsDataPayloadType = {
      token,
      event_type: "work_anniversary",
      limit: 5,
    };
    dispatchGetMySpaceWorkAnniversaryAction(finalData);
  }, []);

  useEffect(() => {
    dispatchResetUpcomingBirthdayList();
    let finalData: GetMySpaceUpcomingEventsDataPayloadType = {
      token,
      event_type: "birthday",
      limit: 5,
    };
    dispatchGetMySpaceUpcomingBirthDayAction(finalData);
  }, []);

  const handleErrorModal = () => {
    if (mySpaceSuccess === 0) {
      if (mySpaceStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!mySpaceError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={mySpaceStatusCode}
          />
        );
      } else if (!!mySpaceError && mySpaceStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!mySpaceError}
            title="Error"
            message={mySpaceError}
            buttonText="OK"
            onPress={() => {
              dispatchResetMySpaceError();
            }}
          />
        );
      } else if (!!masterError && masterStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!masterError}
            title="Error"
            message={masterError}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
            }}
          />
        );
      } else if (!!authError && authStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!authError}
            title="Error"
            message={authError}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="HR Dashboard" />
      </div>
      <div className="w-100 d-flex mt-4" style={{ gap: "2%" }}>
        <div style={{ width: "68%" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "34% 30% 34%",
              gap: "2%",
            }}
          >
            <div>
              <PeopleOnLeave
                data={peopleOnLeaveData}
                handleTogglePeopleOnLeaveModal={handleTogglePeopleOnLeaveModal}
                fetching={peopleOnLeaveFetching}
              />
            </div>
            <div className="w-100">
              <AttendanceDetails
                attendanceAverage={attendanceAverage}
                fetching={attendanceAverageFetching}
              />
            </div>
            <div>
              <EmployeeOnProbation
                data={allFinacUsersList}
                handleToggleProbationModal={handleToggleProbationModal}
                fetching={authFetching}
              />
            </div>
          </div>
          <div
            className="mt-2"
            style={{
              display: "grid",
              gridTemplateColumns: "50% 50%",
              gap: "2%",
            }}
          >
            <div>
              <OnTimeArrival />
            </div>
            <div>
              <MissingTimesheetUpdates />
            </div>
          </div>
          <div
            className="mt-2"
            style={{
              display: "grid",
              gridTemplateColumns: "50% 50%",
              gap: "2%",
            }}
          >
            <div>
              <EmployeeByLocation />
            </div>
            <div>
              <AttendanceByDepartment />
            </div>
          </div>
        </div>
        <div
          style={{
            width: "29%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: holidayData?.length <= 3 ? "300px" : "320px",
              margin: 0,
              width: "100%",
            }}
          >
            <LoggedInUsersHolidayCalendar
              handleToggleHolidaysModal={handleToggleHolidaysModal}
              data={holidayData}
              fetching={holidayFetching}
            />
          </div>

          <WorkAnniversaries
            data={mySpaceWorkAnniversaryList}
            fetching={workAnniversaryfetching}
          />
          <UpcomingBirthdays
            data={upcomingBirthdayList}
            fetching={upcomingBirthDayFetching}
          />
        </div>
      </div>
      {viewAllHolidays && (
        <HolidayCalenderModalView
          data={holidayCalenderList}
          toggle={handleToggleHolidaysModal}
          isOpen={viewAllHolidays}
        />
      )}
      {allProbationData && (
        <EmployeeOnProbationModal
          data={allFinacUsersList}
          toggle={handleToggleProbationModal}
          isOpen={allProbationData}
        />
      )}
      {allPeopleOnLeaveData && (
        <PeopleOnLeaveModal
          data={peopleOnLeaveData}
          toggle={handleTogglePeopleOnLeaveModal}
          isOpen={allPeopleOnLeaveData}
        />
      )}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  sideMenus: state.auth.sideMenus,
  userProfileAllData: state.auth.userProfileAllData,
  token: state.auth.token,
  authFetching: state.auth.fetching,
  holidayCalenderList: state.masterData.holidayCalenderList,
  mySpaceWorkAnniversaryList: state.mySpace.mySpaceWorkAnniversaryList,
  workAnniversaryTotalCount: state.mySpace.workAnniversaryTotalCount,
  upcomingBirthdayList: state.mySpace.upcomingBirthdayList,
  upcomingBirthdayTotalCount: state.mySpace.upcomingBirthdayTotalCount,
  upcomingBirthDayFetching: state.mySpace.upcomingBirthDayFetching,
  workAnniversaryfetching: state.mySpace.workAnniversaryfetching,
  allFinacUsersList: state.auth.finacUsersList,
  ///fetching
  userFetching: state.auth.fetching,
  holidayFetching: state.masterData.fetching,

  ///success
  authSuccess: state.auth.success,
  masterSuccess: state.masterData.success,
  mySpaceSuccess: state.mySpace.success,

  ///status code
  authStatusCode: state.auth.statusCode,
  masterStatusCode: state.masterData.statusCode,
  mySpaceStatusCode: state.mySpace.statusCode,

  ///// error
  authError: state.auth.error,
  masterError: state.masterData.error,
  mySpaceError: state.mySpace.error,

  ///leave
  leaveStatus: state.stcoTools.leaveStatus,

  //people on leave
  peopleOnLeaveFetching: state.mySpace.peopleOnLeaveFetching,
  peopleOnLeaveData: state.mySpace.peopleOnLeaveData,

  // attendanceAverage
  attendanceAverageFetching: state.mySpace.attendanceAverageFetching,
  attendanceAverage: state.mySpace.attendanceAverage,
});
const mapDispatchToProps = (dispatch: any) => ({
  ///holiday calender
  dispatchResetMasterDataHolidayCalenderListing: () =>
    dispatch(resetHolidayCalenderList()),
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => dispatch(getMasterDataHolidayCalenderAction(data)),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),

  ///all users
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetUserDetails: () => dispatch(resetFinacUsersList()),

  // upcoming events
  dispatchGetMySpaceWorkAnniversaryAction: (
    data: GetMySpaceUpcomingEventsDataPayloadType
  ) => dispatch(getMySpaceWorkAnniversaryAction(data)),
  dispatchResetMySpaceWorkAnniversaryList: () => {
    dispatch(resetMySpaceWorkAnniversaryList());
  },
  dispatchGetMySpaceUpcomingBirthDayAction: (
    data: GetMySpaceUpcomingEventsDataPayloadType
  ) => {
    dispatch(getMySpaceUpcomingBirthDayAction(data));
  },
  dispatchResetUpcomingBirthdayList: () => {
    dispatch(resetUpcomingBirthdayList());
  },
  ////people on leave
  dispatchGetPeopleOnLeaveAction: (data: GetMySpacePeopleOnLeavePayloadType) =>
    dispatch(getPeopleOnLeaveAction(data)),
  dispatchResetPeopleOnLeaveList: () => {
    dispatch(resetPeopleOnLeaveList());
  },
  ///my space
  dispatchResetMySpaceSuccess: () => dispatch(resetMySpaceSuccess()),
  dispatchResetMySpaceError: () => dispatch(resetMySpaceError()),
  dispatchResetMySpaceStatusCode: () => dispatch(resetMySpaceStatusCode()),
  /// attendance average
  dispatchGetAttendanceAverage: (data: GetAttendanceAveragePayloadType) => {
    dispatch(getAttendanceAverageAction(data));
  },
  dispatchResetAttendanceAverage: () => dispatch(resetAttendanceAverage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HRDashboard);
